<template>
   <div v-if="visible" class="reap-page">

      <!-- ══ SOBRES FLOTANTES DE FONDO ══ -->
      <div class="reap-bg-envs">
         <svg v-for="n in 7" :key="n" :class="`bg-env bg-env-${n}`" viewBox="0 0 512 400" xmlns="http://www.w3.org/2000/svg">
            <rect x="0" y="0" width="512" height="400" rx="24" fill="none" stroke="currentColor" stroke-width="20"/>
            <polyline points="0,0 256,220 512,0" fill="none" stroke="currentColor" stroke-width="20"/>
         </svg>
      </div>
      <!-- ══ ESTADO 1A: PROCESANDO ══ -->
      <template v-if="cargando">
         <div class="reap-content" style="animation:fadeInDown .6s ease">

            <div class="reap-icon-wrapper">
               <div class="reap-ring reap-ring-1"></div>
               <div class="reap-ring reap-ring-2"></div>
               <div class="reap-ring reap-ring-3"></div>
               <div class="reap-icon-circle">
                  <v-icon size="54" color="white">fas fa-envelope-open-text</v-icon>
               </div>
            </div>

            <h1 class="reap-title">Procesando solicitudes</h1>
            <p class="reap-subtitle">UNICAES · Colecturía Digital</p>
            <div class="reap-divider"></div>

            <div class="reap-cards">
               <div class="reap-card reap-fade-in" style="animation-delay:.2s">
                  <div class="reap-card-label">
                     <v-icon small class="mr-1" color="#deab2f">fas fa-history</v-icon>
                     Ciclo origen
                  </div>
                  <div class="reap-card-value reap-ciclo">{{ cicloOrigen }}</div>
               </div>
               <div class="reap-card-arrow">
                  <v-icon color="#deab2f" size="28">fas fa-long-arrow-alt-right</v-icon>
               </div>
               <div class="reap-card reap-fade-in" style="animation-delay:.4s">
                  <div class="reap-card-label">
                     <v-icon small class="mr-1" color="#deab2f">fas fa-calendar-check</v-icon>
                     Ciclo destino
                  </div>
                  <div class="reap-card-value reap-ciclo">{{ cicloDestino }}</div>
               </div>
            </div>

            <div class="reap-bar-track">
               <div class="reap-bar-indeterminate"></div>
            </div>
            <p class="reap-msg">Por favor espere, este proceso puede tomar varios minutos.<br/>No cierre esta ventana.</p>
         </div>
      </template>

      <!-- ══ ESTADO 3: COMPLETADO ══ -->
      <template v-else>
         <div class="reap-content" style="animation:fadeInDown .5s ease">

            <div class="reap-done-icon-wrapper">
               <div class="reap-ring reap-ring-1" style="border-color:rgba(222,171,47,.4)"></div>
               <div class="reap-ring reap-ring-2" style="border-color:rgba(222,171,47,.25)"></div>
               <div class="reap-done-circle">
                  <v-icon size="52" color="#deab2f">fas fa-check-circle</v-icon>
               </div>
            </div>

            <h1 class="reap-title">¡Proceso Completado!</h1>
            <p class="reap-subtitle">{{ cicloOrigen }} → {{ cicloDestino }}</p>
            <div class="reap-divider"></div>

            <div class="reap-cards reap-cards--done">
               <div class="reap-card reap-fade-in" style="animation-delay:.1s">
                  <div class="reap-card-label">
                     <v-icon small class="mr-1" color="#4caf50">fas fa-check</v-icon>Enviadas
                  </div>
                  <div class="reap-card-value" style="color:#4caf50;font-size:36px">{{ progEnviados }}</div>
               </div>
               <div class="reap-card reap-fade-in" style="animation-delay:.25s">
                  <div class="reap-card-label">
                     <v-icon small class="mr-1" color="#ef5350">fas fa-times</v-icon>Fallidas
                  </div>
                  <div class="reap-card-value" style="color:#ef5350;font-size:36px">{{ progFallidos }}</div>
               </div>
               <div class="reap-card reap-fade-in" style="animation-delay:.4s">
                  <div class="reap-card-label">
                     <v-icon small class="mr-1" color="#deab2f">fas fa-envelope</v-icon>Total
                  </div>
                  <div class="reap-card-value" style="color:#deab2f;font-size:36px">{{ progTotal }}</div>
               </div>
            </div>

            <div style="display:flex; gap:14px; justify-content:center; flex-wrap:wrap; margin-top:28px;">
               <button class="reap-close-btn reap-excel-btn" @click="descargarExcel">
                  <v-icon small color="#deab2f" class="mr-2">fas fa-file-excel</v-icon>
                  Descargar Excel
               </button>
               <button class="reap-close-btn" @click="cerrarYRecargar">
                  <v-icon small color="white" class="mr-2">fas fa-check</v-icon>
                  Cerrar
               </button>
            </div>
         </div>
      </template>

   </div>
</template>

<script>
import ExcelJS from 'exceljs'

export default {
   name: 'ReaplicacionProgreso',
   props: {
      visible:          { type: Boolean, default: false },
      cargando:         { type: Boolean, default: false },
      animando:         { type: Boolean, default: false },
      cicloOrigen:      { type: String,  default: '' },
      cicloDestino:     { type: String,  default: '' },
      listaReaplicacion:{ type: Array,   default: () => [] }
   },
   emits: ['cerrar'],
   computed: {
      progTotal()    { return this.listaReaplicacion.length },
      progEnviados() { return this.listaReaplicacion.filter(i =>  i.notificado).length },
      progFallidos() { return this.listaReaplicacion.filter(i => !i.notificado).length },
   },
   methods: {
      cerrarYRecargar() {
         this.$emit('cerrar')
         setTimeout(() => location.reload(), 150)
      },
      async descargarExcel() {
         const wb = new ExcelJS.Workbook()
         wb.creator = 'Colecturía Digital'
         wb.created = new Date()

         const COLOR_TITULO   = 'FFA00402' // rojo institucional
         const COLOR_HEADER   = 'FF7B0301'
         const COLOR_ENVIADO  = 'FFE2EFDA' // verde claro
         const COLOR_FALLIDO  = 'FFFCE4E4' // rojo claro

         const estiloTitulo = {
            font:      { bold: true, color: { argb: 'FFFFFFFF' }, size: 13 },
            fill:      { type: 'pattern', pattern: 'solid', fgColor: { argb: COLOR_TITULO } },
            alignment: { vertical: 'middle', horizontal: 'center' }
         }
         const estiloHeader = {
            font:      { bold: true, color: { argb: 'FFFFFFFF' }, size: 10 },
            fill:      { type: 'pattern', pattern: 'solid', fgColor: { argb: COLOR_HEADER } },
            alignment: { vertical: 'middle', horizontal: 'center' }
         }
         const estiloFila = (notificado, par) => ({
            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: notificado ? (par ? 'FFFFFFFF' : COLOR_ENVIADO) : COLOR_FALLIDO } },
            font: { size: 10, color: { argb: notificado ? 'FF000000' : 'FFA00402' } },
            alignment: { vertical: 'middle' }
         })

         const ws = wb.addWorksheet('Reaplicación')
         ws.columns = [
            { width: 14 }, // Carnet
            { width: 28 }, // Nombres
            { width: 28 }, // Apellidos
            { width: 22 }, // Tipo Beneficio
            { width: 14 }, // Notificado
         ]

         // Título principal
         const titRow = ws.addRow([`Reaplicación de Solicitudes de Beca — ${this.cicloOrigen} → ${this.cicloDestino}`])
         titRow.height = 24
         ws.mergeCells(`A${titRow.number}:E${titRow.number}`)
         titRow.getCell('A').style = estiloTitulo

         // Resumen
         const resRow = ws.addRow([
            `Total: ${this.progTotal}`,
            `Notificados: ${this.progEnviados}`,
            `Fallidos: ${this.progFallidos}`,
            '', ''
         ])
         resRow.height = 16
         ws.mergeCells(`A${resRow.number}:B${resRow.number}`)
         resRow.getCell('A').style = { font: { bold: true, size: 10, color: { argb: 'FF2E7D32' } }, fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE8F5E9' } }, alignment: { horizontal: 'center' } }
         resRow.getCell('C').style = { font: { bold: true, size: 10, color: { argb: 'FFA00402' } }, fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFCE4E4' } }, alignment: { horizontal: 'center' } }

         // Headers
         const hRow = ws.addRow(['Carnet', 'Nombres', 'Apellidos', 'Tipo de Beneficio', 'Notificado'])
         hRow.height = 18
         hRow.eachCell(cell => { cell.style = estiloHeader })

         // Datos
         this.listaReaplicacion.forEach((item, i) => {
            const dr = ws.addRow([
               item.carnet    || '',
               item.nombres   || '',
               item.apellidos || '',
               item.tipoBeneficio || '',
               item.notificado ? 'Sí' : 'No',
            ])
            dr.eachCell(cell => { cell.style = estiloFila(item.notificado, i % 2 === 0) })
         })

         // Descargar
         const buffer = await wb.xlsx.writeBuffer()
         const blob   = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
         const url    = URL.createObjectURL(blob)
         const a      = document.createElement('a')
         a.href = url
         a.download = `Reaplicacion_${this.cicloOrigen}_a_${this.cicloDestino}.xlsx`
         a.click()
         URL.revokeObjectURL(url)
      }
   }
}
</script>

<style scoped>
/* ══ BASE ══ */
.reap-page {
   position: fixed; inset: 0; z-index: 999;
   background: linear-gradient(135deg, #6b0101 0%, #A00402 45%, #7a0301 100%);
   display: flex; align-items: center; justify-content: center;
   overflow: hidden; font-family: 'Roboto', sans-serif;
}

/* ══ SOBRES FLOTANTES ══ */
.reap-bg-envs { position: absolute; inset: 0; pointer-events: none; overflow: hidden; }
.bg-env { position: absolute; color: rgba(222,171,47,0.07); }
.bg-env-1 { width:220px; bottom:-40px; left: -60px; animation:envDrift1 20s ease-in-out infinite; }
.bg-env-2 { width:130px; top:  -30px; right:-40px; animation:envDrift2 15s ease-in-out infinite; }
.bg-env-3 { width: 80px; top:   80px; left: 100px; animation:envDrift3  9s ease-in-out infinite; }
.bg-env-4 { width:180px; top:   25%;  right:-60px; animation:envDrift1 18s ease-in-out infinite reverse; }
.bg-env-5 { width: 70px; bottom:80px; right:140px; animation:envDrift2  8s ease-in-out infinite; }
.bg-env-6 { width:110px; bottom:-20px; left: 38%;  animation:envDrift3 13s ease-in-out infinite reverse; }
.bg-env-7 { width:160px; top:   10%;  left: -50px; animation:envDrift1 22s ease-in-out infinite; }
@keyframes envDrift1 { 0%,100%{transform:translateY(0) rotate(-8deg)}  50%{transform:translateY(-18px) rotate(4deg)} }
@keyframes envDrift2 { 0%,100%{transform:translateY(0) rotate(12deg)}  50%{transform:translateY( 14px) rotate(-6deg)} }
@keyframes envDrift3 { 0%,100%{transform:translateY(0) rotate(0deg)}   50%{transform:translateY(-10px) rotate(15deg)} }

/* ══ CONTENIDO CENTRAL ══ */
@keyframes fadeInDown {
   from { opacity:0; transform:translateY(-28px); }
   to   { opacity:1; transform:translateY(0); }
}
.reap-content {
   position: relative; z-index: 2;
   text-align: center; padding: 40px 28px;
   max-width: 680px; width: 100%;
}

/* ── Ícono con anillos ── */
.reap-icon-wrapper, .reap-done-icon-wrapper {
   position: relative; display: inline-flex;
   align-items: center; justify-content: center;
   margin-bottom: 28px; width: 120px; height: 120px;
}
.reap-ring {
   position: absolute; border-radius: 50%;
   border: 2px solid rgba(255,255,255,.25);
   animation: pulseRing 2.4s ease-out infinite;
}
.reap-ring-1 { width:100px; height:100px; animation-delay:  0s; }
.reap-ring-2 { width:120px; height:120px; animation-delay: .8s; }
.reap-ring-3 { width:140px; height:140px; animation-delay:1.4s; }
@keyframes pulseRing {
   0%  { transform:scale(.85); opacity:.8; }
   70% { transform:scale(1.2); opacity:0; }
   100%{ transform:scale(1.2); opacity:0; }
}
.reap-icon-circle, .reap-done-circle {
   width:88px; height:88px; border-radius:50%;
   background:rgba(255,255,255,.12);
   border:2px solid rgba(222,171,47,.5);
   display:flex; align-items:center; justify-content:center;
   backdrop-filter:blur(6px);
   animation:iconPulse 2s ease-in-out infinite;
}
@keyframes iconPulse {
   0%,100%{ box-shadow:0 0 0 0 rgba(222,171,47,0); }
   50%    { box-shadow:0 0 20px 6px rgba(222,171,47,.25); }
}

/* ── Textos ── */
.reap-title {
   color:#fff; font-size:clamp(22px,4vw,34px); font-weight:700;
   letter-spacing:2px; text-transform:uppercase;
   text-shadow:0 2px 12px rgba(0,0,0,.4); margin:0 0 6px;
}
.reap-subtitle {
   color:#deab2f; font-size:14px; letter-spacing:4px;
   text-transform:uppercase; margin:0 0 20px;
}
.reap-divider {
   width:60px; height:3px; margin:0 auto 28px;
   background:linear-gradient(90deg,transparent,#deab2f,transparent);
}
.reap-msg {
   color:rgba(255,255,255,.45); font-size:13px; line-height:1.8; margin:0;
}

/* ── Cards ciclo / completado ── */
.reap-cards {
   display:flex; flex-wrap:wrap; gap:14px;
   align-items:center; justify-content:center; margin-bottom:28px;
}
.reap-cards--done { gap:20px; }
.reap-card-arrow  { display:flex; align-items:center; }
.reap-card {
   background:rgba(255,255,255,.08);
   border:1px solid rgba(222,171,47,.25);
   border-radius:12px; padding:16px 24px;
   min-width:160px; backdrop-filter:blur(6px);
}
.reap-card-label {
   color:rgba(255,255,255,.6); font-size:11px;
   text-transform:uppercase; letter-spacing:1px;
   margin-bottom:8px; display:flex; align-items:center;
}
.reap-card-value { color:#fff; font-size:16px; font-weight:500; }
.reap-ciclo      { font-size:22px; font-weight:700; letter-spacing:3px; color:#deab2f; }

/* ── Barra indeterminada ── */
.reap-bar-track {
   width:280px; height:5px; background:rgba(255,255,255,.15);
   border-radius:99px; overflow:hidden; margin:0 auto 20px;
}
.reap-bar-indeterminate {
   height:100%; width:40%; border-radius:99px;
   background:linear-gradient(90deg,#deab2f,#fff,#deab2f);
   animation:barSlide 1.6s ease-in-out infinite;
}
@keyframes barSlide {
   0%  { transform:translateX(-100%); }
   100%{ transform:translateX(350%); }
}

/* ── Fade in ── */
.reap-fade-in { opacity:0; animation:fadeInUp .6s ease forwards; }
@keyframes fadeInUp {
   from { opacity:0; transform:translateY(18px); }
   to   { opacity:1; transform:translateY(0); }
}

/* ── Botón cerrar ── */
.reap-close-btn {
   margin-top:28px; padding:12px 40px;
   background:rgba(222,171,47,.15);
   border:2px solid #deab2f; border-radius:999px;
   color:#deab2f; font-size:15px; font-weight:700;
   letter-spacing:1px; text-transform:uppercase; cursor:pointer;
   display:inline-flex; align-items:center;
   transition:background .25s, color .25s, transform .15s;
}
.reap-close-btn:hover { background:#deab2f; color:#6b0101; transform:scale(1.03); }
.reap-excel-btn { background:rgba(255,255,255,.08); border-color:rgba(222,171,47,.5); color:rgba(255,255,255,.8); }
.reap-excel-btn:hover { background:rgba(222,171,47,.2); color:#fff; }
</style>
